import { Button, SvgExternalLink } from '@loomhq/lens';
import React from 'react';
import { useDispatch } from 'react-redux';

import * as analytics from 'utilities/analytics';

import InstallLoomIOSImg from 'img/workspace-onboarding/install-loom-ios.png';

import DashboardOnboardingCard, {
  DashboardOnboardingSecondaryAction,
} from '../..';
import { completeElementHandler } from '../../../utilities';
import { DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED } from '../../../../../../constants/events';
import { MOBILE_PAGE_URI } from '../../../../../../constants/routes';
import { useGetSelectedWorkspace } from '../../../../../../hooks/workspace';
import { INSTALL_IOS_APP_CARD_KEY } from '../../../../../../../../shared/constants/workspaceOnboarding';

const SUPPORT_ARTICLE_LINK =
  'https://support.loom.com/hc/en-us/articles/360002799977-Is-there-a-Loom-mobile-app-';

const InstalliOSAppCard = () => {
  const dispatch = useDispatch();
  const header = 'Install Loom for iOS';
  const description = 'Record and watch videos on the go.';

  const selectedWorkspace = useGetSelectedWorkspace();

  if (!selectedWorkspace) {
    return null;
  }

  const secondaryAction = (
    <DashboardOnboardingSecondaryAction
      icon={<SvgExternalLink />}
      onClick={() => {
        window.open(SUPPORT_ARTICLE_LINK);

        analytics.track(DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED, {
          type: 'secondary',
          card: INSTALL_IOS_APP_CARD_KEY,
        });
      }}
    >
      Learn how
    </DashboardOnboardingSecondaryAction>
  );

  const primaryAction = (
    <Button
      htmlTag="a"
      href={MOBILE_PAGE_URI}
      icon={<SvgExternalLink />}
      target="_blank"
      onClick={() => {
        completeElementHandler(
          dispatch,
          INSTALL_IOS_APP_CARD_KEY,
          selectedWorkspace.id
        );

        analytics.track(DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED, {
          type: 'primary',
          card: INSTALL_IOS_APP_CARD_KEY,
        });
      }}
    >
      Get the app
    </Button>
  );
  const centerpiece = <img src={InstallLoomIOSImg} />;

  return (
    <DashboardOnboardingCard
      cardKey={INSTALL_IOS_APP_CARD_KEY}
      heading={header}
      description={description}
      centerpiece={centerpiece}
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      completeMessage="Check your text messages or visit the App Store to finish installing."
    />
  );
};

export default InstalliOSAppCard;
